import React from "react";

function AddEncounter({ contactID }) {
  const openEncounter = () => {
    const url =
      process.env.REACT_APP_CAREPLAN +
      "/dist/EncounterPortal/index.html?contactid=" +
      contactID;
    window.open(url, "encounter");
  };

  return (
    <button
      className="me-1 btn bg-safy3-1 text-white"
      onClick={() => openEncounter()}
    >
      <i className={"fas fa-plus-circle me-1 text-white"} />
      Encounter
    </button>
  );
}

export default AddEncounter;
